/**
 * JWT для веба (magic link / Telegram): все запросы к ИИ на бэке требуют Authorization.
 */

export function getAuthToken() {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem('authToken');
}

/** Заголовки для JSON fetch; добавляет Bearer при наличии токена. */
export function jsonHeadersWithAuth(base = {}) {
  const headers = { ...base };
  const token = getAuthToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

/** true если пользователь вошёл (есть токен в localStorage). */
export function isWebAuthenticated() {
  return Boolean(getAuthToken());
}
